<template>
  <q-btn
    v-bind="$attrs"
    round
    icon="fa fa-upload"
    color="primary"
    @click="pickFiles"
  >
    <q-file
      v-bind="$attrs"
      ref="uploader"
      v-model="value"
      class="col hidden"
      @input="onPick"
    />
  </q-btn>
</template>

<script>
import { readFileBase64 } from '@/utils'

export default {
  name: 'LwfBtnFile',
  inheritAttrs: false,
  data () {
    return {
      value: null
    }
  },
  methods: {
    pickFiles (e) {
      this.$refs.uploader.pickFiles(e)
    },
    _readFile (f) {

    },
    async onPick (files) {
      this.$emit(
        'input',
        await (Array.isArray(files)
          ? Promise.all(files.map(readFileBase64))
          : readFileBase64(files))
      )
    }
  }
}
</script>

<style scoped>

</style>
